import { CompanyAPI } from '@api';

const printAntt = (params) => CompanyAPI.printAntt(params)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { printAntt };
